import { connect } from 'react-redux';
import Home from '../../pages/Home';
import { toggleModal } from '../slices/announceModalSlice';

const mapState = (state) => ({ isConnected: state.user.isConnected });

const mapDispatch = (dispatch) => ({
  toggleModal: () => {
    const action = toggleModal();
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(Home);
